import { tokens } from '@ping/design-tokens';
import type { TextStyle } from 'react-native';

export interface Typography {
  fontFamily: {
    base: string;
    fallback: string;
  };
  fontSize: {
    largeTitle: number;
    title: number;
    headline: number;
    body: number;
    footnote: number;
    caption: number;
  };
  fontWeight: {
    regular: string;
    medium: string;
    semibold: string;
    bold: string;
  };
  lineHeight: {
    tight: number;
    normal: number;
    relaxed: number;
  };
}

export const typography: Typography = {
  fontFamily: {
    base: tokens.typography.fontFamily.base,
    fallback: tokens.typography.fontFamily.fallback,
  },
  fontSize: {
    largeTitle: tokens.typography.fontSize.largeTitle,
    title: tokens.typography.fontSize.title,
    headline: tokens.typography.fontSize.headline,
    body: tokens.typography.fontSize.body,
    footnote: tokens.typography.fontSize.footnote,
    caption: tokens.typography.fontSize.caption,
  },
  fontWeight: {
    regular: String(tokens.typography.fontWeight.regular),
    medium: String(tokens.typography.fontWeight.medium),
    semibold: String(tokens.typography.fontWeight.semibold),
    bold: String(tokens.typography.fontWeight.bold),
  },
  lineHeight: {
    tight: tokens.typography.lineHeight.tight,
    normal: tokens.typography.lineHeight.normal,
    relaxed: tokens.typography.lineHeight.relaxed,
  },
};

export function createTextStyle(
  size: keyof Typography['fontSize'],
  weight: keyof Typography['fontWeight'] = 'regular',
  lineHeight?: keyof Typography['lineHeight']
): TextStyle {
  return {
    fontFamily: typography.fontFamily.base,
    fontSize: typography.fontSize[size],
    fontWeight: typography.fontWeight[weight] as TextStyle['fontWeight'],
    lineHeight: lineHeight
      ? typography.fontSize[size] * typography.lineHeight[lineHeight]
      : undefined,
  };
}
